import axiosInstance from '../../api/axios';

const baseUrl = '/lessons';

const LessonService = {
  listAllLessons: async () => {
    try {
      const response = await axiosInstance.get(baseUrl);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch lessons');
      }
    } catch (error) {
      throw error;
    }
  },

  showLessonDetails: async (id) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/${id}`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch lesson details');
      }
    } catch (error) {
      throw error;
    }
  },

  createNewLessons: async (lessonsData) => {
    try {
      const response = await axiosInstance.post(baseUrl, { lessons: lessonsData });
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to create lessons');
      }
    } catch (error) {
      throw error;
    }
  },

  updateLessonDetails: async (id, data) => {
    try {
      const response = await axiosInstance.put(`${baseUrl}/${id}`, data);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to update lesson details');
      }
    } catch (error) {
      throw error;
    }
  },

  deleteLesson: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}`);
      return response.data; // Return the entire response data
    } catch (error) {
      throw error;
    }
  },
  deleteLessonMedia: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}/media`);
      if (response.status === 204) {
        return { success: true };
      } else {
        throw new Error('Failed to delete lesson media');
      }
    } catch (error) {
      throw error;
    }
  },
};

export default LessonService;